const { ajaxHandler, spinnerElem, toast } = require("./utilities/utilities");

/**
 * Update license info
 *
 * @since 1.0.0
 */
document.addEventListener('DOMContentLoaded', function () {
    const licensePage = document.querySelector('.licenses');
    const editWebsiteButtons = document.querySelectorAll('.edit-website');
    const addWebsiteForm = document.querySelector('#add-website-form');
    const updateWebsiteForm = document.querySelector('#update-website-form');
    const copyLicenseButtons = document.querySelectorAll('.copy-license-key');

    if (licensePage) {
        // Handle add website click event
        if (addWebsiteForm) {
            addWebsiteForm.addEventListener('submit', async (e) => {
                e.preventDefault();

                const submitBtn = document.querySelector('button[submit-website]');
                const formData = new FormData(addWebsiteForm);
                formData.append('action', 'products_register_website');

                const submitBtnPrevState = submitBtn.innerHTML;
                submitBtn.setAttribute('disabled', true);
                submitBtn.innerHTML = spinnerElem;

                const res = await ajaxHandler(formData);

                try {
                    if (res) {
                        const { data, success } = res;
                        if (success) {
                            // Reload page.
                            location.reload();
                        } else {
                            toast.error(data);
                        }
                    }
                } catch (error) {
                    toast.error(data);
                } finally {
                    // Enable button
                    submitBtn.removeAttribute('disabled');
                    submitBtn.innerHTML = submitBtnPrevState;
                }
            });
        }

        if (updateWebsiteForm) {
            updateWebsiteForm.addEventListener('submit', async (e) => {
                e.preventDefault();

                const submitBtn = document.querySelector('button[update-website]');
                const formData = new FormData(updateWebsiteForm);
                formData.append('action', 'products_update_website');

                const submitBtnPrevState = submitBtn.innerHTML;
                submitBtn.setAttribute('disabled', true);
                submitBtn.innerHTML = spinnerElem;

                const res = await ajaxHandler(formData);

                try {
                    if (res) {
                        const { data, success } = res;
                        if (success) {
                            // Reload page.
                            location.reload();
                        } else {
                            toast.error(data);
                        }
                    }
                } catch (error) {
                    toast.error(error);
                } finally {
                    // Enable button
                    submitBtn.removeAttribute('disabled');
                    submitBtn.innerHTML = submitBtnPrevState;
                }
            });
        }

        // Handle edit website click event
        editWebsiteButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                const licenseId = e.currentTarget.dataset.id;
                const subscriptionId = e.currentTarget.dataset.subscriptionId;
                const URL = e.currentTarget.dataset.url;

                // Set value of update form.
                updateWebsiteForm.querySelector('[name=id]').value = licenseId;
                updateWebsiteForm.querySelector('[name=subscription_id]').value = subscriptionId;
                updateWebsiteForm.querySelector('[name=website_url]').value = URL;
            });
        });

        // Copy license key
        copyLicenseButtons.forEach(button => {
            button.addEventListener('click', async (e) => {
                try {
                    const licenseKey = button.previousElementSibling.getAttribute('data-license-key');
                    await navigator.clipboard.writeText(licenseKey);
                    toast.success('Copied to clipboard successfully!');
                } catch (error) {
                    toast.error('License copy failed!');
                }
            })
        })

        const isSubdomain = function (url) {
            url = url.replace(/\/+$/, ""); // Remove if any / (slash) and the end
            const regex = new RegExp(/^([a-z]+\:\/{2})?([\w-]+\.[\w-]+\.\w+)$/);
            return regex.test(url);
        }
    }
})
